class StackPlayerClassifier {
    isPlayerFromPrimaryStack(player) {
        return false;
    }

    isPlayerFromSecondaryStack(player) {
        return false;
    }

    isPlayerFromThirdStack(player) {
        return false;
    }

    isPlayerFromFourthStack(player) {
        return false;
    }

    isPlayerFromFifthStack(player) {
        return false;
    }
}

export {StackPlayerClassifier};
